import qs from "qs";
/**
 * 解析url例所有参数
 */
function parseParames() {

    let search = window.location.search;
    if (!search || search.length <= 1) {
        return {};
    }
    const query = qs.parse(search.substring(1))

    return query;

}
/**
 * 获取地址栏请求参数集合
 */
  function getQueryParams() {
    return parseParames();
}
/**
 * 获取请求参数
 * @param {string} key  参数key
 * @param {string} defaultvalue  默认值
 */
  function getQueryParameter(key, defaultvalue = "") {
    const parameters = parseParames();
    if (!parameters.hasOwnProperty(key)) {
        return defaultvalue;
    }
    return parameters[key];

}
/**
 * 解析返回异常消息
 * @param {error} error 
 * @param {string} defaultValue 
 */
  function parseErrorMsg(error, defaultValue) {
    if(!error||!error.response){
        return defaultValue;
    }
    if( error.response&&error.response.data&&error.response.data.message){
        return error.response.data.message;
    }
     if(  error.response&&error.response.data&&error.response.data.msg){
         return error.response.data.msg ;
     }  
     return defaultValue;
}
export default {
    getQueryParams,
    getQueryParameter,
    parseErrorMsg
}